import { useEffect, useState } from 'react';
import { getSiteHostname } from 'utilities/utils';

export const getStorageDataSnapshot: () => Object | null = () => {
  const dataString = window.localStorage.getItem(`${getSiteHostname()} data`);
  try {
    if (!dataString) {
      return null;
    }
    return JSON.parse(dataString);
  } catch {
    // @TODO consider Sentry error here...
    return null;
  }
};

export const useStorageData = () => {
  const [storageData, setStorageData] = useState<Object | null>(getStorageDataSnapshot);

  useEffect(() => {
    const updateStorageData = (event?: Event) => {
      if (
        event instanceof StorageEvent &&
        event.key !== null &&
        event.key !== `${getSiteHostname()} data`
      ) return;
      setStorageData(getStorageDataSnapshot());
    };
    window.addEventListener('storage', updateStorageData);
    // Catch writes between the first render and subscription.
    updateStorageData();

    return () => window.removeEventListener('storage', updateStorageData);
  }, []);

  return {
    storageData,
    hasStorageData: Boolean(storageData),
  };
};
